// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kvBD","rootNoMargin":"styles_rootNoMargin__3d-3v"};